import React from "react";

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const getCSSRule = (css) => {
  const split = css.split("_");
  let rule = "";
  if (split[0] === "") {
    if (split[2]) {
      rule = split[1] + capitalizeFirstLetter(split[2]);
    } else {
      rule = split[1];
    }
  } else {
    if (split[1]) {
      rule = split[0] + capitalizeFirstLetter(split[1]);
    } else {
      rule = css;
    }
  }

  if (rule === "contentWidth") {
    rule = "maxWidth";
  } else if (rule === "contentPosition") {
    rule = "alignContent";
  } else if (rule === "titleColor") {
    rule = "color";
  } else if (rule === "imageSize") {
    rule = "width";
  } else if (rule === "align") {
    rule = "textAlign";
  }

  return rule;
};

const getCSSValue = (value) => {
  if (typeof value === "object") {
    const valueArr = Object.keys(value);
    if (valueArr.includes("size") || valueArr.includes("imageSize")) {
      return `${value.size + value.unit}`;
    }
    if (valueArr.includes("top")) {
      return `${value.top + value.unit} ${value.right + value.unit} ${
        value.bottom + value.unit
      } ${value.left + value.unit}`;
    }
    // return `${value.top + value.unit} ${value.right + value.unit} ${value.bottom + value.unit} ${value.left + value.unit}`
  } else {
    if (value === "middle") {
      return "center";
    } else {
      return value;
    }
  }
};

export const getStyles = (settings) => {
  let parsedCSS = Object.keys(settings).map((key) => {
    const newKey = getCSSRule(key);
    return { [newKey]: settings[key] };
  });

  let newStyles = {};

  parsedCSS.forEach((style) => {
    Object.keys(style).map((key) => {
      if (style[key] && key !== "undefined") {
        newStyles = { ...newStyles, [key]: getCSSValue(style[key]) };
      }
    });
  });
  return newStyles;
};

export const getVertPos = (props) => {
  let position = "flex-start";
  if (props === "top") {
    position = "flex-start";
  } else if (props === "bottom") {
    position = "flex-end";
  } else if (props === "center") {
    position = "center";
  } else {
    position = "center";
  }
  return position;
};
export const getColSize = (settings) => {
  if (settings._inline_size) return settings._inline_size;
  return settings._column_size;
};
